// @flow
import PagesConfig from "../Config";
import type {
  PagesConfigType,
  PagesConfigOptions,
  PagesToggles
} from "../../types";

export const defaultConfig = {
  header: {
    logoMod: "logo",
    isActionToolsShown: true,
    isLogActionsShown: true,
    isVisible: true
  },
  footer: {
    isVisible: true
  },
  joinBar: {
    isVisible: true
  }
};

const checkPathIsEnabled = (pageCfg: PagesConfigType, toggles: PagesToggles) =>
  typeof pageCfg.toggle === "undefined" || !!toggles[pageCfg.toggle];

export default {
  getComponentCfg: (
    path: string,
    options?: PagesConfigOptions,
    toggles: PagesToggles = {}
  ): ?PagesConfigType => {
    const tempConf = PagesConfig.find(
      (pageCfg) =>
        path.toLowerCase().startsWith(pageCfg.key.toLowerCase()) &&
        checkPathIsEnabled(pageCfg, toggles)
    );

    const mergedConfs = (key: "header" | "footer" | "joinBar") => ({
      ...defaultConfig[key],
      ...(tempConf?.[key] || {}),
      ...(options?.overridesByExactKeys?.[tempConf?.key]?.[key] ||
        options?.overrides?.[key] ||
        {})
    });

    return {
      ...tempConf,
      ...defaultConfig,
      ...(options?.overrides || {}),
      header: mergedConfs("header"),
      footer: mergedConfs("footer"),
      joinBar: mergedConfs("joinBar")
    };
  }
};
